import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["warehouseFields"]

  connect() {
    this.toggleWarehouseFields()
    this.addEventListeners()
  }

  addEventListeners() {
    const radioButtons = this.element.querySelectorAll(
      'input[type="radio"][name$="[address_type]"]',
    )
    radioButtons.forEach((radio) => {
      radio.addEventListener("change", () => this.toggleWarehouseFields())
    })
  }

  toggleWarehouseFields() {
    const warehouseRadio = this.element.querySelector(
      'input[type="radio"][name$="[address_type]"][value="warehouse"]',
    )
    if (warehouseRadio && warehouseRadio.checked) {
      this.warehouseFieldsTarget.classList.remove("d-none")
    } else {
      this.warehouseFieldsTarget.classList.add("d-none")
    }
  }
}
